import {mergeMap} from 'rxjs/operators';
import { RoleGuard } from './role.guard';
import { AuthGuard } from './auth.guard';
import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CombinedAuthRoleGuard implements CanActivate {

    constructor(private authGuard: AuthGuard, private roleGuard: RoleGuard) {}

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => 
        this.authGuard.canActivate(route, state).pipe(mergeMap(result => result ? this.roleGuard.canActivate(route, state) : of(result)));
}